import { Button, Modal } from '@orobix/orobix-fe-components'
import { FormikHelpers } from 'formik'
import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { arrayMove, List } from 'react-movable'

import useStyles from './ClassesPriorityModal.styles'

interface ClassesPriorityModalProps<FormValues> {
  setModal: React.Dispatch<React.SetStateAction<boolean>>
  setFieldValue: FormikHelpers<FormValues>['setFieldValue']
  initialValues: string[]
}

const ClassesPriorityModal = <FormValues,>({
  setModal,
  setFieldValue,
  initialValues,
}: ClassesPriorityModalProps<FormValues>) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const containerRef = useRef<HTMLDivElement>(null)
  const [productClasses, setProductClasses] = useState<string[]>(initialValues)

  return (
    <Modal
      size="md"
      onCloseRequest={() => setModal(false)}
      title={t('Change classes priority')}
      footer={
        <>
          <Button
            onClick={() => setModal(false)}
            label={t('Cancel')}
            type="default"
            buttonType="button"
          />

          <Button
            label={t('Confirm')}
            onClick={() => {
              setModal(false)
              setFieldValue('patchesClassPriority', productClasses)
            }}
            type="action"
            buttonType="button"
          />
        </>
      }
    >
      <div ref={containerRef}>
        <p>{t('Drag and drop classes to reorder them.')}</p>
        <List
          lockVertically
          values={productClasses}
          onChange={({ oldIndex, newIndex }) =>
            setProductClasses(
              arrayMove<string>(productClasses, oldIndex, newIndex)
            )
          }
          // eslint-disable-next-line react/jsx-props-no-spreading
          renderList={({ children, props }) => <div {...props}>{children}</div>}
          renderItem={({ value, index, props }) => (
            // eslint-disable-next-line react/jsx-props-no-spreading
            <div {...props} className={classes.classItem}>
              <span className={classes.index}>{index ? index + 1 : 1}</span>
              <span className={classes.label}>{value}</span>
            </div>
          )}
          container={containerRef.current}
        />
      </div>
    </Modal>
  )
}

export default ClassesPriorityModal
